export default function useDifferenceInMinutes(d1: Date, d2: Date) {
  d1 = new Date(d1);
  d2 = new Date(d2);

  return Math.floor(Math.abs(d1.getTime() - d2.getTime()) / 1000 / 60)
}
